import React from 'react'
import proj1 from '../img/pro1.png'
import proj2 from '../img/pro2.png'
import proj3 from '../img/pro3.png'
import proj4 from '../img/pro5.png'
import proj5 from '../img/pro4.png'
import proj6 from '../img/pro6.png'

const Work = () => {
  return (
    <div className=' max-w-[90%] mx-auto p-2' id='work'>

     <div className='flex flex-col justify-center items-center my-0 mb-10' id="about">
  <p className='text-4xl font-bold primary-color text-center mt-10'>My Works</p>
  <p className='text-gray-400 text-2xl text-center text-white'>
  Check out Some of my recents works</p>
</div>

     <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-10'>
      <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
        h-[200px]  bg-cover relative'>
            <img src={proj1}  alt=""/>
            <div className='opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'>EDiamond</span>
                <span className='text-xl font-bold text-white text-center text-blue-200'>This is a PHP e-commerce Site</span>
                <div className='pt-8 text-center'>
                    <a href="/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                        font-bold text-lg'>
                            Live
                            </button>

                    </a>
                </div>
            </div>
        </div>
        <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
        h-[200px]  bg-cover relative'>
            <img src={proj2}  alt=""/>
            <div className='opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'>LMS</span>
                <span className='text-xl font-bold text-white text-center  text-blue-200'>This is a LMS using  HTML and CSS </span>
                <div className='pt-8 text-center'>
                    <a href="/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                        font-bold text-lg'>
                            Live
                            </button>

                    </a>
                </div>
            </div>
        </div>
        <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
        h-[200px]  bg-cover relative'>
            <img src={proj3}  alt=""/>
            <div className='opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'>CMA</span>
                <span className='text-xl font-bold text-white text-center  text-blue-200'>This is a University Website using  HTML and CSS </span>
                <div className='pt-8 text-center'>
                    <a href="/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                        font-bold text-lg'>
                            Live
                            </button>

                    </a>
                </div>
            </div>
        </div>
        <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
        h-[200px]  bg-cover relative'>
            <img src={proj4}  alt=""/>
            <div className='opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'>My Note App</span>
                <span className='text-xl font-bold text-white text-center text-blue-200'>This is a Mobile App using  Reactnative with MySQl Database </span>
                <div className='pt-8 text-center'>
                    <a href="/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                        font-bold text-lg'>
                            Live
                            </button>

                    </a>
                </div>
            </div>
        </div>
        <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
        h-[200px]  bg-cover relative'>
            <img src={proj5}  alt=""/>
            <div className='opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'>AIBS</span>
                <span className='text-xl font-bold text-white text-center text-blue-200'>This is a University Website using  HTML and CSS </span>
                <div className='pt-8 text-center'>
                    <a href="/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                        font-bold text-lg'>
                            Live
                            </button>

                    </a>
                </div>
            </div>
        </div>
        <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
        h-[200px]  bg-cover relative'>
            <img src={proj6}  alt=""/>
            <div className='opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'>Pet Medicare App</span>
                <span className='text-xl font-bold text-white text-center text-blue-200'>This is a Mobile App using  Android with Firebase Database </span>
                <div className='pt-8 text-center'>
                    <a href="/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 
                        font-bold text-lg'>
                            Live
                            </button>

                    </a>
                </div>
            </div>
        </div>
     </div>
     




    </div>
  )
}

export default Work
